import selectFilter from './selectFilter';
import { action } from 'satcheljs/lib/legacy';
export default action('clearFilter')(function clearFilter(actionSource) {
    selectFilter('All', actionSource);
});
//# sourceMappingURL=clearFilter.js.map